import "../css/title.css";
import MediaQuery from "react-responsive";

function Title() {
    return (
    <section className="container-fluid">
        <div className="row fill-height align-items-center">
            <div className="col-1"></div>
            <MediaQuery maxWidth={"992px"}>
                <div className="col-10 text-center">
                    <h1 id="name" className="ns mb-4">PAUL<br/>GRAY</h1>
                    <h2 id="label" className="fw-lighter marginbtm">game developer & 3d generalist</h2>
                    <div className="mx-auto marginbtm w-75" style={{padding : "42.25% 0 0 0", position : "relative"}}><iframe src="https://player.vimeo.com/video/1097168864?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" style={{position:"absolute", top : 0, left : 0, width : "100%", height : "100%"}} title="Paul Gray 2025 Demo Reel"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
                    <a href="#about" className="text-decoration-none">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" className="bi bi-chevron-double-down mb-4" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                            <path fillRule="evenodd" d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                        </svg><br/>
                        <span className="text-black">About</span>
                    </a>
                </div>
            </MediaQuery>
            <MediaQuery minWidth={"993px"}>
                <div className="col-4 pt-5 text-left">
                    <h1 id="name" className="ns mb-4">PAUL<br/>GRAY</h1>
                    <h2 id="label" className="fw-lighter ps-3">game developer & 3d generalist</h2>
                </div>
                <div className="col-2 text-center mt-auto mb-5">
                    <a href="#about" className="text-decoration-none">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" className="bi bi-chevron-double-down mb-4" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                            <path fillRule="evenodd" d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                        </svg><br/>
                        <span className="text-black">About</span>
                    </a>
                </div>
                <div className="col-4 text-center">
                    <div style={{padding : "56.25% 0 0 0", position : "relative"}}><iframe src="https://player.vimeo.com/video/1097168864?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" style={{position:"absolute", top : 0, left : 0, width : "100%", height : "100%"}} title="Paul Gray 2025 Demo Reel"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
                </div>
            </MediaQuery>
            <div className="col-1"></div>
        </div>
    </section>
    );
}

export default Title;